
import "vue-form-generator/dist/vfg-core.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/js/bootstrap.js";
import "./assets/styles/fonts.css";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import Vue from "vue";

import FlagIcon from "vue-flag-icon";
import VueGtm from "vue-gtm";
import VueAnalytics from "vue-analytics";
import VueReadMore from "vue-read-more";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "@/plugins/language/i18n";
import Cookies from "js-cookie";
import httpServiceUser from "@/http/http-user.js";


import { BootstrapVue, IconsPlugin, ToastPlugin, VBTooltipPlugin  } from "bootstrap-vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Loader from "./components/fragments/Loader";
import LanguageBar from "./components/LanguageBar";
import Pagination from "./components/fragments/Pagination";
import Multiselect from "vue-multiselect";
import ScrollToTopBtn from "@/components/fragments/ScrollToTopBtn";
import fieldBsSwitch from "@/components/fragments/dynamic_fields/fieldBsSwitch";
import moment from "moment";
import flxUtils from './plugins/flexben_utils';
import httpFlexbenService from "@/http/http-flexben.js";

library.add(fas);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("contentLoader", Loader);
Vue.component("listPagination", Pagination);
Vue.component("LanguageBar", LanguageBar);
Vue.component("multiselect", Multiselect);
Vue.component("scroll-to-top-btn", ScrollToTopBtn);
Vue.component("field-BsSwitch", fieldBsSwitch);

Vue.config.productionTip = false;

// require("./assets/styles/normalize.css");
require("./http/http-common.js");

Vue.filter("titleCase", function (value) {
	if (!value) return "";
	value = value
		.toLowerCase()
		.replace("-", " ")
		.split(" ");
	for (var i = 0; i < value.length; i++) {
		value[i] = value[i].charAt(0).toUpperCase() + value[i].slice(1);
	}
	return value.join(" ");
});

// Vue.use(auth);
Vue.use(FlagIcon);
Vue.use(ToastPlugin);
Vue.use(IconsPlugin);
Vue.use(BootstrapVue);
Vue.use(VBTooltipPlugin);
Vue.use(VueReadMore);
Vue.config.productionTip = false;
Vue.mixin({
	methods: {
		flxUserLevel(affiliatePartnerId = null) {
			if (affiliatePartnerId) {
				return {
					hasAccess: true,
					userLevel: 'affiliate_partner',
				};
			}
			let flxCookie = Cookies.get("flxCookie");
			let hasAccess = false;
			let userLevel = "";

			if (typeof flxCookie != "undefined") {
				hasAccess = true;
				if (flxCookie === "admin") {
					userLevel = "admin";
				} else if (flxCookie === "client") {
					userLevel = "client";
				} else if (flxCookie === "beneficiary") {
					userLevel = "beneficiary";
				}
			}

			return {
				hasAccess: hasAccess,
				userLevel: userLevel,
			};
		},
		/**
		 * Resolves Flexben client employment (incl. flexben company_id for API paths).
		 * Does not use session selectedCompany.company_id — that is the Up platform company id, not Flexben's.
		 */
		flxEnsureClientEmployment() {
			return new Promise((resolve, reject) => {
				const employment = this.$store.getters.flx_activeEmployment;
				if (employment != null && employment.company_id != null) {
					resolve(employment);
					return;
				}
				const token = Cookies.get("token");
				const userLink = Cookies.get("userLink");
				const rawCompany = sessionStorage.getItem("selectedCompany");
				if (!token || !userLink || !rawCompany) {
					reject(new Error("missing_auth_or_company"));
					return;
				}
				let company;
				try {
					company = JSON.parse(rawCompany);
				} catch (e) {
					reject(e);
					return;
				}
				httpFlexbenService.userService
					.syncUserData({
						auth_token: token,
						link: userLink,
						role: "client",
						company: company,
					})
					.then((response) => {
						const list = response.data && response.data.employments;
						if (list && list.length > 0) {
							const first = list[0];
							sessionStorage.setItem("flx_active_employments", JSON.stringify(list));
							sessionStorage.setItem("flx_active_employment", JSON.stringify(first));
							this.$store.commit("setActiveEmployment", first);
							resolve(first);
						} else {
							reject(new Error("no_employments"));
						}
					})
					.catch(reject);
			});
		},
		/**
		 * Method to check flexben route
		 * @returns {boolean}
		 */
		isFlexbenRoute() {
			return this.$route.meta.isFlxRoute || false;
		},
		checkNotEmptyObj(obj) {
			if (Array.isArray(obj) && obj.length > 0) {
				return true;
			}
			return (
				typeof obj !== "undefined" &&
				obj !== null &&
				!(
					(obj.constructor === Array || obj.constructor === Object) &&
					Object.keys(obj).length === 0
				)
			);
		},
		scrollToTop(pixels = 0) {
			window.scrollTo({ top: pixels, behavior: "smooth" });
		},
		moment(date, format, fromFormat) {
			return moment(date, fromFormat).format(format);
		},
		generateRange(startNr, endNr) {
			let returnData = [];
			for (let i = startNr; i <= endNr; i++) {
				returnData.push(i);
			}
			return returnData;
		},
		sendClickToGA(category, action, label) {
			if (this.$ga) {
				this.$ga.event({
					eventCategory: category,
					eventAction: action,
					eventLabel: label,
				});
			}
		},
		flxModuleCan(toCheck, checkModulePermissions = null) {
			if (checkModulePermissions == null) {
				const ae = this.$store.getters.flx_activeEmployment;
				checkModulePermissions = ae != null ? ae.module_permissions : [];
			}

			return this.checkFlxModulePermission(checkModulePermissions, toCheck);
		},
		checkFlxModulePermission(modulePermissions, toCheck) {
			return flxUtils.checkFlxModulePermission(modulePermissions, toCheck);
		},
		flxTrackData(data) {
			flxUtils.trackData(data);
		},
		checkNpsSurvey(type){
			let x = parseInt(
				Cookies.get(type + "_count")
				? Cookies.get(type)
				: 0
				);
			  return  Cookies.get(type) ? 5 : x;
		},
		fromBinaryStr(binary) {
			// 1: create an array of bytes
			const bytes = Uint8Array.from({ length: binary.length }, (_, index) =>
			  binary.charCodeAt(index)
			);

			// 2: decode the byte data into a string
			const decoder = new TextDecoder('utf-8');
			return decoder.decode(bytes);
        },
        pushRoute(routeName){
          this.$router.push({	name: routeName , replace: true});
          // this.$forceUpdate();
        },
        clearSessionStorageByPrefix(prefix) {
          Object.keys(sessionStorage).forEach(key => {
            if (key.startsWith(prefix)) {
                sessionStorage.removeItem(key);
            }
          });
        },
		getCaptchaKey() {
			return process.env.VUE_APP_CAPTCHA_KEY
		},
		logoutCompany(companyId, token) {
			httpServiceUser.userService
				.logoutUser(
					companyId,
					token
				)
				.then(function (response) {
					return response;
				})
				.catch(error => {
					
				})
				.then(response => {
				});
		},
		showModalPopup(elementId, show) {
			if (show) {
				document.getElementById(elementId).style.visibility = "visible";
			} else {
				document.getElementById(elementId).style.visibility = "hidden";
			}
		},
		// for cms marketing
		isUserAdmin(user) {
			return (
				user ?
					user.companies ? user.companies[0].user_config.roles.includes('ADMIN'):
					user.config.roles.includes('ADMIN')
				: false
			);
		},
		isUserITAdmin(user) {
			return (
				user ?
					user.companies ? user.companies[0].user_config.roles.includes('ADMINIT'):
					user.config.roles.includes('ADMINIT')
				: false
			);
		},
		isUserNew(user) {
			return (
				user ? user.status !== '' : false
			);
		},
		getImagePath() {
			return (
				"https://api.uponline.ro/cms/release/"
			);
		},
		getUser(force = false) {

			if (Cookies.get("user_data") && !force) {
				return JSON.parse(Cookies.get("user_data"));
			} else {
				httpServiceUser.userService
					.getUserData(Cookies.get('userLink'), Cookies.get('token'))
					.then((response) => {
						Cookies.set("user_data", response.data, {
							expires: 6000000 / (24 * 60 * 60),
							sameSite: "Strict",
						});
						return response.data;
					});
			}
		},
	},

});

if (!FileReader.prototype.readAsBinaryString) {
	FileReader.prototype.readAsBinaryString = function (fileData) {
		var binary = "";
		var pt = this;
		var reader = new FileReader();
		reader.onload = function () {
			var bytes = new Uint8Array(reader.result);
			var length = bytes.byteLength;
			for (var i = 0; i < length; i++) {
				binary += String.fromCharCode(bytes[i]);
			}
			//pt.result  - readonly so assign binary
			pt.content = binary;
			pt.onload();
		};
		reader.readAsArrayBuffer(fileData);
	};
}

new Vue({
	delimiters: ["[[", "]]"],
	router,
	store,
	i18n,
	render: (h) => h(App),
	mounted() {
		const isProd = process.env.NODE_ENV === "production";
		if (Cookies.get("cookies_analytics") !== null) {
			Vue.use(VueGtm, {
				id: "GTM-N2W59PJ", // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
				// queryParams: {
				// 	// Add url query string when load gtm.js with GTM ID (optional)
				// 	gtm_auth: "AB7cDEf3GHIjkl-MnOP8qr",
				// 	gtm_preview: "env-4",
				// 	gtm_cookies_win: "x"
				// },
				enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
				debug: true, // Whether or not display console logs debugs (optional)
				loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
				vueRouter: router, // Pass the router instance to automatically sync with router (optional)
				// ignoredViews: ["homepage"] // If router, you can exclude some routes name (case insensitive) (optional)
			});
			// Vue.use(VueGtag, {
			// 	config: {id: "UA-59971354-2"},
			// 	router,
			// 	// debug: {
			// 	// 	enabled: true, // isProd;
			// 	// 	sendHitTask: true, // isProd;
			// 	// },
			// 	enabled: true,
			// });
			Vue.use(VueAnalytics, {
				id: "UA-59971354-2",
				router,
				checkDuplicatedScript: true,
				enabled: (typeof process.env.VUE_APP_ENABLE_GOOGLE_ANALITICS != 'undefined') ? parseInt(process.env.VUE_APP_ENABLE_GOOGLE_ANALITICS) : 1,
				debug: {
					enabled: false, // default value
					trace: false, // default value
					sendHitTask: true, // default value
				},
			});
		}
	},
}).$mount("#app");
